import { Link } from "react-router-dom";

const stats = [
  { value: "350+", label: "专属漫画" },
  { value: "8.6亿", label: "累计阅读" },
  { value: "128部", label: "尊享典藏" },
  { value: "24h", label: "极速更新" },
];

function Hero() {
  return (
    <section className="relative flex min-h-screen items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20dark%20luxury%20fantasy%20backdrop%2C%20golden%20ornate%20patterns%20and%20glowing%20gold%20particles%20floating%20in%20deep%20black%20space%2C%20ancient%20golden%20dragon%20silhouette%20and%20celestial%20clouds%2C%20premium%20wealth%20and%20majesty%20atmosphere%2C%20abstract%20artistic%2C%20cinematic%20lighting&width=1600&height=900&seq=hero-tuhao&orientation=landscape"
          alt="土豪漫画网尊享专属漫画奢华背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-transparent to-background-950/50"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6 py-28 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-widest text-primary-300 backdrop-blur-sm">
            <i className="ri-vip-diamond-fill text-sm"></i>
            贵族专属特权阅读
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-50 md:text-6xl">
            尊享 <span className="text-gold-grad">漫画</span> 世界
            <br />
            钻石级 <span className="text-gold-grad">专属阅读</span> 体验
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-foreground-300 md:text-lg">
            尊享漫画、钻石漫画、贵族漫画、豪华漫画，土豪漫画网汇聚四大专属专区，豪华画质、极速更新、纯净阅读，满足你独一无二的贵族专属漫画需求。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
            >
              <i className="ri-book-open-fill"></i>
              立即阅读
            </Link>
            <Link
              to="/vip"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500/50 bg-background-950/40 px-7 py-3.5 text-sm font-semibold text-primary-300 backdrop-blur-sm transition hover:bg-primary-500/10 cursor-pointer"
            >
              <i className="ri-vip-diamond-line"></i>
              解锁专属特权
            </Link>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-800 bg-background-800 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-900/80 px-6 py-5 backdrop-blur-sm">
              <p className="font-heading text-2xl font-bold text-gold-grad md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-400 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-primary-500 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl"></i>
      </div>
    </section>
  );
}

export default Hero;